let styledata3 =[
    {
        id : 64,
        imgurl : 'img/section6/section6_9.jpg',
        text : '@k.river.j'
    },
    {
        id : 65,
        imgurl : 'img/section6/section6_10.jpg',
        text : '@weird.co.kr'
    },
    {
        id : 66,
        imgurl : 'img/section6/section6_11.jpg',
        text : '@prettysw_'
    },
    {
        id : 67,
        imgurl : 'img/section6/section6_12.jpg',
        text : '@2m_ariel'
    },
]

export default styledata3;